package de.ohhhmhhh.backend.models.model.revocation

import kotlinx.datetime.Instant
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class RevocationEntity(
    @SerialName("id")
    val id: String,
    @SerialName("firstName")
    val firstName: String,
    @SerialName("lastName")
    val lastName: String,
    @SerialName("emailAddress")
    val emailAddress: String,
    @SerialName("contractType")
    val contractType: RevocationContractTypeEntity,
    @SerialName("contractId")
    val contractId: String,
    @SerialName("state")
    val state: RevocationStateEntity,
    @SerialName("errors")
    val errors: String?,
    @SerialName("message")
    val message: String?,
    @SerialName("sentMail")
    val sentMail: Instant?,
    @SerialName("created")
    val created: Instant,
    @SerialName("completed")
    val completed: Instant?,
)
